import Caruso from "./Basketball-NFT/Caruso.jpg";
import Ben from "./Basketball-NFT/Ben.jpg";
import ChrisPaul from "./Basketball-NFT/Chris.jpg";
import Dennis from "./Basketball-NFT/Dennis.jpg";
import Derrick from "./Basketball-NFT/Derrick.jpg";
import Booker from "./Basketball-NFT/Debin.jpg";
import Mitchell from "./Basketball-NFT/Donovan.jpg";
import Wade from "./Basketball-NFT/Dwayne.jpg";
import Giannis from "./Basketball-NFT/Giannis.jpg";
import Hakeem from "./Basketball-NFT/Hakeem.jpg";
import Ja from "./Basketball-NFT/Ja.jpg";
import Jaylen from "./Basketball-NFT/Brown.jpg";
import Jayson from "./Basketball-NFT/Jayson.jpg";
import Jimmy from "./Basketball-NFT/Jimmy.jpg";
import Joel from "./Basketball-NFT/Joel.jpg";
import Kevin from "./Basketball-NFT/Kevin.jpg";
import Lebron from "./Basketball-NFT/Lebron.jpg";
import Klay from "./Basketball-NFT/Klay.jpg";
import Kobe from "./Basketball-NFT/Kobe.jpg";
import Kyrie from "./Basketball-NFT/Kyrie.jpg";
import Luka from "./Basketball-NFT/Luka.jpg";
// import Manu from "./Basketball-NFT/Manu.jpg";
import Gasol from "./Basketball-NFT/Marc.jpg";
import Siakam from "./Basketball-NFT/Pascal.jpg";
import Paul from "./Basketball-NFT/Paul.jpg";
import Ricky from "./Basketball-NFT/Ricky.jpg";
import Steph from "./Basketball-NFT/Steph.jpg";
import Magic from "./Basketball-NFT/Magic.jpg";
import Trae from "./Basketball-NFT/Trae.jpg";
import Zach from "./Basketball-NFT/Zach.jpg";
import Artist from "./Basketball-NFT/avatar.png";
import Drake from "../CelebrityArt/Celebrity-NFT/Drake.png";
import Paraphase from "../RandomArt/RandomArt-NFT/PARAPHASE.jpg";
const items = [
  {
    id: 1,
    title: "Alex.C",
    artist: "Femi",
    artistImage: Artist,
    image: Caruso,
    info: "Digital art of Alex Caruso, AC fresh from our Players collection",
    cover: true,
    center: true,
    price: "0.2ETH",
    collection: "Player Collection",
    post: "Digital Creative Artist",
    collections: [
      { id: 1, name: "Player Collection", pic: Steph },
      { id: 2, name: "Celebrity Collection", pic: Drake },
      { id: 3, name: "RandomArt Collection", pic: Paraphase },
    ],
    artistStory:
      "Femi a talented artist born out of Nigeria from the trenches of Lagos sees art as a way to express his thoughts and tell stories from his minted pieces. Femi has been in the art business for more than a decade now and with the emergence of NFTs he plans on taking showing people and the world at large how talented he is with his pieces, follow Femis Works via his social media pages to know more about him ",
  },
  {
    id: 2,
    title: "Ben.S",
    artist: "Femi",
    artistImage: Artist,
    image: Ben,
    info: "Digital art of Ben Simmons from our Players collection",
    cover: true,
    center: true,
    price: "0.2ETH",
    collection: "Player Collection",
    post: "Digital Creative Artist",
    collections: [
      { id: 1, name: "Player Collection", pic: Steph },
      { id: 2, name: "Celebrity Collection", pic: Drake },
      { id: 3, name: "RandomArt Collection", pic: Paraphase },
    ],
    artistStory:
      "Femi a talented artist born out of Nigeria from the trenches of Lagos sees art as a way to express his thoughts and tell stories from his minted pieces. Femi has been in the art business for more than a decade now and with the emergence of NFTs he plans on taking showing people and the world at large how talented he is with his pieces, follow Femis Works via his social media pages to know more about him ",
  },
  {
    id: 3,
    title: "Chris.P",
    artist: "Femi",
    artistImage: Artist,
    image: ChrisPaul,
    info: "Digital art of Chris Paul, point god from our Players collection",
    cover: true,
    center: true,
    price: "0.2ETH",
    collection: "Player Collection",
    post: "Digital Creative Artist",
    collections: [
      { id: 1, name: "Player Collection", pic: Steph },
      { id: 2, name: "Celebrity Collection", pic: Drake },
      { id: 3, name: "RandomArt Collection", pic: Paraphase },
    ],
    artistStory:
      "Femi a talented artist born out of Nigeria from the trenches of Lagos sees art as a way to express his thoughts and tell stories from his minted pieces. Femi has been in the art business for more than a decade now and with the emergence of NFTs he plans on taking showing people and the world at large how talented he is with his pieces, follow Femis Works via his social media pages to know more about him ",
  },
  {
    id: 4,
    title: "Dennis.S",
    artist: "Femi",
    artistImage: Artist,
    image: Dennis,
    info:
      "Digital art of Dennis Scrhoder, the Menance from our Players collection",
    cover: true,
    center: true,
    price: "0.2ETH",
    collection: "Player Collection",
    post: "Digital Creative Artist",
    collections: [
      { id: 1, name: "Player Collection", pic: Steph },
      { id: 2, name: "Celebrity Collection", pic: Drake },
      { id: 3, name: "RandomArt Collection", pic: Paraphase },
    ],
    artistStory:
      "Femi a talented artist born out of Nigeria from the trenches of Lagos sees art as a way to express his thoughts and tell stories from his minted pieces. Femi has been in the art business for more than a decade now and with the emergence of NFTs he plans on taking showing people and the world at large how talented he is with his pieces, follow Femis Works via his social media pages to know more about him ",
  },
  {
    id: 5,
    title: "Derrick.R",
    artist: "Femi",
    artistImage: Artist,
    image: Derrick,
    info: "Digital art of Derrick Rose 🌹 from our Players collection",
    cover: true,
    center: true,
    price: "0.2ETH",
    collection: "Player Collection",
    post: "Digital Creative Artist",
    collections: [
      { id: 1, name: "Player Collection", pic: Steph },
      { id: 2, name: "Celebrity Collection", pic: Drake },
      { id: 3, name: "RandomArt Collection", pic: Paraphase },
    ],
    artistStory:
      "Femi a talented artist born out of Nigeria from the trenches of Lagos sees art as a way to express his thoughts and tell stories from his minted pieces. Femi has been in the art business for more than a decade now and with the emergence of NFTs he plans on taking showing people and the world at large how talented he is with his pieces, follow Femis Works via his social media pages to know more about him ",
  },
  {
    id: 6,
    title: "Devin.B",
    artist: "Femi",
    artistImage: Artist,
    image: Booker,
    info: "Digital art of Devin Booker from our Players collection",
    cover: true,
    center: true,
    price: "0.2ETH",
    collection: "Player Collection",
    post: "Digital Creative Artist",
    collections: [
      { id: 1, name: "Player Collection", pic: Steph },
      { id: 2, name: "Celebrity Collection", pic: Drake },
      { id: 3, name: "RandomArt Collection", pic: Paraphase },
    ],
    artistStory:
      "Femi a talented artist born out of Nigeria from the trenches of Lagos sees art as a way to express his thoughts and tell stories from his minted pieces. Femi has been in the art business for more than a decade now and with the emergence of NFTs he plans on taking showing people and the world at large how talented he is with his pieces, follow Femis Works via his social media pages to know more about him ",
  },
  {
    id: 7,
    title: "Donovan.M",
    artist: "Femi",
    artistImage: Artist,
    image: Mitchell,
    info:
      "Digital art of Donovan Mitchell 🕷, the Spida  from our Players collection",
    cover: true,
    center: true,
    price: "0.2ETH",
    collection: "Player Collection",
    post: "Digital Creative Artist",
    collections: [
      { id: 1, name: "Player Collection", pic: Steph },
      { id: 2, name: "Celebrity Collection", pic: Drake },
      { id: 3, name: "RandomArt Collection", pic: Paraphase },
    ],
    artistStory:
      "Femi a talented artist born out of Nigeria from the trenches of Lagos sees art as a way to express his thoughts and tell stories from his minted pieces. Femi has been in the art business for more than a decade now and with the emergence of NFTs he plans on taking showing people and the world at large how talented he is with his pieces, follow Femis Works via his social media pages to know more about him ",
  },
  {
    id: 8,
    title: "D.Wade",
    artist: "Femi",
    artistImage: Artist,
    image: Wade,
    info:
      "Digital art of Dwayne Wade ⚡, the Flash from our Players collection",
    cover: true,
    center: true,
    price: "0.2ETH",
    collection: "Player Collection",
    post: "Digital Creative Artist",
    collections: [
      { id: 1, name: "Player Collection", pic: Steph },
      { id: 2, name: "Celebrity Collection", pic: Drake },
      { id: 3, name: "RandomArt Collection", pic: Paraphase },
    ],
    artistStory:
      "Femi a talented artist born out of Nigeria from the trenches of Lagos sees art as a way to express his thoughts and tell stories from his minted pieces. Femi has been in the art business for more than a decade now and with the emergence of NFTs he plans on taking showing people and the world at large how talented he is with his pieces, follow Femis Works via his social media pages to know more about him ",
  },
  {
    id: 9,
    title: "Giannis.A",
    artist: "Femi",
    artistImage: Artist,
    image: Giannis,
    info:
      "Digital art of Giannis Antentokunpo, the Greek Freak from our Players collection",
    cover: true,
    center: true,
    price: "0.2ETH",
    collection: "Player Collection",
    post: "Digital Creative Artist",
    collections: [
      { id: 1, name: "Player Collection", pic: Steph },
      { id: 2, name: "Celebrity Collection", pic: Drake },
      { id: 3, name: "RandomArt Collection", pic: Paraphase },
    ],
    artistStory:
      "Femi a talented artist born out of Nigeria from the trenches of Lagos sees art as a way to express his thoughts and tell stories from his minted pieces. Femi has been in the art business for more than a decade now and with the emergence of NFTs he plans on taking showing people and the world at large how talented he is with his pieces, follow Femis Works via his social media pages to know more about him ",
  },
  {
    id: 10,
    title: "Hakeem.O",
    artist: "Femi",
    artistImage: Artist,
    image: Hakeem,
    info:
      "Digital art of Hakeem Olajuwon, the dream from our Players collection",
    cover: true,
    center: true,
    price: "0.2ETH",
    collection: "Player Collection",
    post: "Digital Creative Artist",
    collections: [
      { id: 1, name: "Player Collection", pic: Steph },
      { id: 2, name: "Celebrity Collection", pic: Drake },
      { id: 3, name: "RandomArt Collection", pic: Paraphase },
    ],
    artistStory:
      "Femi a talented artist born out of Nigeria from the trenches of Lagos sees art as a way to express his thoughts and tell stories from his minted pieces. Femi has been in the art business for more than a decade now and with the emergence of NFTs he plans on taking showing people and the world at large how talented he is with his pieces, follow Femis Works via his social media pages to know more about him ",
  },
  {
    id: 11,
    title: "Ja.M",
    artist: "Femi",
    artistImage: Artist,
    image: Ja,
    info: "Digital art of Ja Morant from our Players collection",
    cover: true,
    center: true,
    price: "0.2ETH",
    collection: "Player Collection",
    post: "Digital Creative Artist",
    collections: [
      { id: 1, name: "Player Collection", pic: Steph },
      { id: 2, name: "Celebrity Collection", pic: Drake },
      { id: 3, name: "RandomArt Collection", pic: Paraphase },
    ],
    artistStory:
      "Femi a talented artist born out of Nigeria from the trenches of Lagos sees art as a way to express his thoughts and tell stories from his minted pieces. Femi has been in the art business for more than a decade now and with the emergence of NFTs he plans on taking showing people and the world at large how talented he is with his pieces, follow Femis Works via his social media pages to know more about him ",
  },
  {
    id: 12,
    title: "Jaylen.B",
    artist: "Femi",
    artistImage: Artist,
    image: Jaylen,
    info: "Digital art of Jaylen Brown from our Players collection",
    cover: true,
    center: true,
    price: "0.2ETH",
    collection: "Player Collection",
    post: "Digital Creative Artist",
    collections: [
      { id: 1, name: "Player Collection", pic: Steph },
      { id: 2, name: "Celebrity Collection", pic: Drake },
      { id: 3, name: "RandomArt Collection", pic: Paraphase },
    ],
    artistStory:
      "Femi a talented artist born out of Nigeria from the trenches of Lagos sees art as a way to express his thoughts and tell stories from his minted pieces. Femi has been in the art business for more than a decade now and with the emergence of NFTs he plans on taking showing people and the world at large how talented he is with his pieces, follow Femis Works via his social media pages to know more about him ",
  },
  {
    id: 13,
    title: "Jayson.T",
    artist: "Femi",
    artistImage: Artist,
    image: Jayson,
    info: "Digital art of Jayson Tatum from our Players collection",
    cover: true,
    center: true,
    price: "0.2ETH",
    collection: "Player Collection",
    post: "Digital Creative Artist",
    collections: [
      { id: 1, name: "Player Collection", pic: Steph },
      { id: 2, name: "Celebrity Collection", pic: Drake },
      { id: 3, name: "RandomArt Collection", pic: Paraphase },
    ],
    artistStory:
      "Femi a talented artist born out of Nigeria from the trenches of Lagos sees art as a way to express his thoughts and tell stories from his minted pieces. Femi has been in the art business for more than a decade now and with the emergence of NFTs he plans on taking showing people and the world at large how talented he is with his pieces, follow Femis Works via his social media pages to know more about him ",
  },
  {
    id: 14,
    title: "Jimmy.B",
    artist: "Femi",
    artistImage: Artist,
    image: Jimmy,
    info:
      "Digital art of Jimmy Butler, Jimmy Buckets from our Players collection",
    cover: true,
    center: true,
    price: "0.2ETH",
    collection: "Player Collection",
    post: "Digital Creative Artist",
    collections: [
      { id: 1, name: "Player Collection", pic: Steph },
      { id: 2, name: "Celebrity Collection", pic: Drake },
      { id: 3, name: "RandomArt Collection", pic: Paraphase },
    ],
    artistStory:
      "Femi a talented artist born out of Nigeria from the trenches of Lagos sees art as a way to express his thoughts and tell stories from his minted pieces. Femi has been in the art business for more than a decade now and with the emergence of NFTs he plans on taking showing people and the world at large how talented he is with his pieces, follow Femis Works via his social media pages to know more about him ",
  },
  {
    id: 15,
    title: "Joel.E",
    artist: "Femi",
    artistImage: Artist,
    image: Joel,
    info: "Digital art of Joel Embid, The Process from our Players collection",
    cover: true,
    center: true,
    price: "0.2ETH",
    collection: "Player Collection",
    post: "Digital Creative Artist",
    collections: [
      { id: 1, name: "Player Collection", pic: Steph },
      { id: 2, name: "Celebrity Collection", pic: Drake },
      { id: 3, name: "RandomArt Collection", pic: Paraphase },
    ],
    artistStory:
      "Femi a talented artist born out of Nigeria from the trenches of Lagos sees art as a way to express his thoughts and tell stories from his minted pieces. Femi has been in the art business for more than a decade now and with the emergence of NFTs he plans on taking showing people and the world at large how talented he is with his pieces, follow Femis Works via his social media pages to know more about him ",
  },
  {
    id: 16,
    title: "Kevin.D",
    artist: "Femi",
    artistImage: Artist,
    image: Kevin,
    info:
      "Digital art of Kevin Durant, easyMoneySniper from our Players collection",
    cover: true,
    center: true,
    price: "0.2ETH",
    collection: "Player Collection",
    post: "Digital Creative Artist",
    collections: [
      { id: 1, name: "Player Collection", pic: Steph },
      { id: 2, name: "Celebrity Collection", pic: Drake },
      { id: 3, name: "RandomArt Collection", pic: Paraphase },
    ],
    artistStory:
      "Femi a talented artist born out of Nigeria from the trenches of Lagos sees art as a way to express his thoughts and tell stories from his minted pieces. Femi has been in the art business for more than a decade now and with the emergence of NFTs he plans on taking showing people and the world at large how talented he is with his pieces, follow Femis Works via his social media pages to know more about him ",
  },
  {
    id: 17,
    title: "Lebron.J",
    artist: "Femi",
    artistImage: Artist,
    image: Lebron,
    info:
      "Digital art of Lebron James 👑, the King from our Players collection",
    cover: true,
    center: true,
    price: "0.2ETH",
    collection: "Player Collection",
    post: "Digital Creative Artist",
    collections: [
      { id: 1, name: "Player Collection", pic: Steph },
      { id: 2, name: "Celebrity Collection", pic: Drake },
      { id: 3, name: "RandomArt Collection", pic: Paraphase },
    ],
    artistStory:
      "Femi a talented artist born out of Nigeria from the trenches of Lagos sees art as a way to express his thoughts and tell stories from his minted pieces. Femi has been in the art business for more than a decade now and with the emergence of NFTs he plans on taking showing people and the world at large how talented he is with his pieces, follow Femis Works via his social media pages to know more about him ",
  },
  {
    id: 18,
    title: "Klay.T",
    artist: "Femi",
    artistImage: Artist,
    image: Klay,
    info:
      "Digital art of Klay Thompson 🌊, Sea Captain from our Players collection",
    cover: true,
    center: true,
    price: "0.2ETH",
    collection: "Player Collection",
    post: "Digital Creative Artist",
    collections: [
      { id: 1, name: "Player Collection", pic: Steph },
      { id: 2, name: "Celebrity Collection", pic: Drake },
      { id: 3, name: "RandomArt Collection", pic: Paraphase },
    ],
    artistStory:
      "Femi a talented artist born out of Nigeria from the trenches of Lagos sees art as a way to express his thoughts and tell stories from his minted pieces. Femi has been in the art business for more than a decade now and with the emergence of NFTs he plans on taking showing people and the world at large how talented he is with his pieces, follow Femis Works via his social media pages to know more about him ",
  },
  {
    id: 19,
    title: "Kobe.B",
    artist: "Femi",
    artistImage: Artist,
    image: Kobe,
    info: "Digital art of Kobe Bryant 🐍, Mamba  M from our Players collection",
    cover: true,
    center: true,
    price: "0.2ETH",
    collection: "Player Collection",
    post: "Digital Creative Artist",
    collections: [
      { id: 1, name: "Player Collection", pic: Steph },
      { id: 2, name: "Celebrity Collection", pic: Drake },
      { id: 3, name: "RandomArt Collection", pic: Paraphase },
    ],
    artistStory:
      "Femi a talented artist born out of Nigeria from the trenches of Lagos sees art as a way to express his thoughts and tell stories from his minted pieces. Femi has been in the art business for more than a decade now and with the emergence of NFTs he plans on taking showing people and the world at large how talented he is with his pieces, follow Femis Works via his social media pages to know more about him ",
  },
  {
    id: 20,
    title: "Kyrie.I",
    artist: "Femi",
    artistImage: Artist,
    image: Kyrie,
    info: "Digital art of Kyrie Irving, Box office from our Players collection",
    cover: true,
    center: true,
    price: "0.2ETH",
    collection: "Player Collection",
    post: "Digital Creative Artist",
    collections: [
      { id: 1, name: "Player Collection", pic: Steph },
      { id: 2, name: "Celebrity Collection", pic: Drake },
      { id: 3, name: "RandomArt Collection", pic: Paraphase },
    ],
    artistStory:
      "Femi a talented artist born out of Nigeria from the trenches of Lagos sees art as a way to express his thoughts and tell stories from his minted pieces. Femi has been in the art business for more than a decade now and with the emergence of NFTs he plans on taking showing people and the world at large how talented he is with his pieces, follow Femis Works via his social media pages to know more about him ",
  },
  {
    id: 21,
    title: "Luka.D",
    artist: "Femi",
    artistImage: Artist,
    image: Luka,
    info: "Digital art of Luka Doncic, Luka Magic from our Players collection",
    cover: true,
    center: true,
    price: "0.2ETH",
    collection: "Player Collection",
    post: "Digital Creative Artist",
    collections: [
      { id: 1, name: "Player Collection", pic: Steph },
      { id: 2, name: "Celebrity Collection", pic: Drake },
      { id: 3, name: "RandomArt Collection", pic: Paraphase },
    ],
    artistStory:
      "Femi a talented artist born out of Nigeria from the trenches of Lagos sees art as a way to express his thoughts and tell stories from his minted pieces. Femi has been in the art business for more than a decade now and with the emergence of NFTs he plans on taking showing people and the world at large how talented he is with his pieces, follow Femis Works via his social media pages to know more about him ",
  },
  {
    id: 22,
    title: "Marc.G",
    artist: "Femi",
    artistImage: Artist,
    image: Gasol,
    info: "Digital art of Marc Gasol from our Players collection",
    cover: true,
    center: true,
    price: "0.2ETH",
    collection: "Player Collection",
    post: "Digital Creative Artist",
    collections: [
      { id: 1, name: "Player Collection", pic: Steph },
      { id: 2, name: "Celebrity Collection", pic: Drake },
      { id: 3, name: "RandomArt Collection", pic: Paraphase },
    ],
    artistStory:
      "Femi a talented artist born out of Nigeria from the trenches of Lagos sees art as a way to express his thoughts and tell stories from his minted pieces. Femi has been in the art business for more than a decade now and with the emergence of NFTs he plans on taking showing people and the world at large how talented he is with his pieces, follow Femis Works via his social media pages to know more about him ",
  },
  {
    id: 23,
    title: "Pascal.S",
    artist: "Femi",
    artistImage: Artist,
    image: Siakam,
    info: "Digital art of Pascal Siakam from our Players collection",
    cover: true,
    center: true,
    price: "0.2ETH",
    collection: "Player Collection",
    post: "Digital Creative Artist",
    collections: [
      { id: 1, name: "Player Collection", pic: Steph },
      { id: 2, name: "Celebrity Collection", pic: Drake },
      { id: 3, name: "RandomArt Collection", pic: Paraphase },
    ],
    artistStory:
      "Femi a talented artist born out of Nigeria from the trenches of Lagos sees art as a way to express his thoughts and tell stories from his minted pieces. Femi has been in the art business for more than a decade now and with the emergence of NFTs he plans on taking showing people and the world at large how talented he is with his pieces, follow Femis Works via his social media pages to know more about him ",
  },
  {
    id: 24,
    title: "Paul.G",
    artist: "Femi",
    artistImage: Artist,
    image: Paul,
    info: "Digital art of Paul George, pandemic P from our Players collection",
    cover: true,
    center: true,
    price: "0.2ETH",
    collection: "Player Collection",
    post: "Digital Creative Artist",
    collections: [
      { id: 1, name: "Player Collection", pic: Steph },
      { id: 2, name: "Celebrity Collection", pic: Drake },
      { id: 3, name: "RandomArt Collection", pic: Paraphase },
    ],
    artistStory:
      "Femi a talented artist born out of Nigeria from the trenches of Lagos sees art as a way to express his thoughts and tell stories from his minted pieces. Femi has been in the art business for more than a decade now and with the emergence of NFTs he plans on taking showing people and the world at large how talented he is with his pieces, follow Femis Works via his social media pages to know more about him ",
  },
  {
    id: 25,
    title: "Ricky.R",
    artist: "Femi",
    artistImage: Artist,
    image: Ricky,
    info: "Digital art of Ricky Rubio from our Players collection",
    cover: true,
    center: true,
    price: "0.2ETH",
    collection: "Player Collection",
    post: "Digital Creative Artist",
    collections: [
      { id: 1, name: "Player Collection", pic: Steph },
      { id: 2, name: "Celebrity Collection", pic: Drake },
      { id: 3, name: "RandomArt Collection", pic: Paraphase },
    ],
    artistStory:
      "Femi a talented artist born out of Nigeria from the trenches of Lagos sees art as a way to express his thoughts and tell stories from his minted pieces. Femi has been in the art business for more than a decade now and with the emergence of NFTs he plans on taking showing people and the world at large how talented he is with his pieces, follow Femis Works via his social media pages to know more about him ",
  },
  {
    id: 26,
    title: "Stephen.C",
    artist: "Femi",
    artistImage: Artist,
    image: Steph,
    info:
      "Digital art of Steph Curry, baby faced assasin from our Players collection",
    cover: true,
    center: true,
    price: "0.2ETH",
    collection: "Player Collection",
    post: "Digital Creative Artist",
    collections: [
      { id: 1, name: "Player Collection", pic: Steph },
      { id: 2, name: "Celebrity Collection", pic: Drake },
      { id: 3, name: "RandomArt Collection", pic: Paraphase },
    ],
    artistStory:
      "Femi a talented artist born out of Nigeria from the trenches of Lagos sees art as a way to express his thoughts and tell stories from his minted pieces. Femi has been in the art business for more than a decade now and with the emergence of NFTs he plans on taking showing people and the world at large how talented he is with his pieces, follow Femis Works via his social media pages to know more about him ",
  },
  {
    id: 27,
    title: "Magic.J",
    artist: "Femi",
    artistImage: Artist,
    image: Magic,
    info: "Digital art of Magic Johnson from our Players collection",
    cover: true,
    center: true,
    price: "0.2ETH",
    collection: "Player Collection",
    post: "Digital Creative Artist",
    collections: [
      { id: 1, name: "Player Collection", pic: Steph },
      { id: 2, name: "Celebrity Collection", pic: Drake },
      { id: 3, name: "RandomArt Collection", pic: Paraphase },
    ],
    artistStory:
      "Femi a talented artist born out of Nigeria from the trenches of Lagos sees art as a way to express his thoughts and tell stories from his minted pieces. Femi has been in the art business for more than a decade now and with the emergence of NFTs he plans on taking showing people and the world at large how talented he is with his pieces, follow Femis Works via his social media pages to know more about him ",
  },
  {
    id: 28,
    title: "Trae.Y",
    artist: "Femi",
    artistImage: Artist,
    image: Trae,
    info: "Digital art of Trae Young ❄, Ice Trae from our Players collection",
    cover: true,
    center: true,
    price: "0.2ETH",
    collection: "Player Collection",
    post: "Digital Creative Artist",
    collections: [
      { id: 1, name: "Player Collection", pic: Steph },
      { id: 2, name: "Celebrity Collection", pic: Drake },
      { id: 3, name: "RandomArt Collection", pic: Paraphase },
    ],
    artistStory:
      "Femi a talented artist born out of Nigeria from the trenches of Lagos sees art as a way to express his thoughts and tell stories from his minted pieces. Femi has been in the art business for more than a decade now and with the emergence of NFTs he plans on taking showing people and the world at large how talented he is with his pieces, follow Femis Works via his social media pages to know more about him ",
  },
  {
    id: 29,
    title: "Zach.L",
    artist: "Femi",
    artistImage: Artist,
    image: Zach,
    info:
      "Digital art of Zach Lavine ✈, Air flight from our Players collection",
    cover: true,
    center: true,
    price: "0.2ETH",
    collection: "Player Collection",
    post: "Digital Creative Artist",
    collections: [
      { id: 1, name: "Player Collection", pic: Steph },
      { id: 2, name: "Celebrity Collection", pic: Drake },
      { id: 3, name: "RandomArt Collection", pic: Paraphase },
    ],
    artistStory:
      "Femi a talented artist born out of Nigeria from the trenches of Lagos sees art as a way to express his thoughts and tell stories from his minted pieces. Femi has been in the art business for more than a decade now and with the emergence of NFTs he plans on taking showing people and the world at large how talented he is with his pieces, follow Femis Works via his social media pages to know more about him ",
  },
];
export default items;
